//---Custom Eases---//

// include CustomEase.min.js for this to work //

//--- BUZZ ---//
// used for a vibrating phone effect //
CustomEase.create("buzz", "M0,0 C0.098,0 0,1.3 0.1,1.3 0.198,1.3 0.102,0 0.2,0 0.292,0 0.202,1.3 0.3,1.3 0.404,1.3 0.304,0 0.4,0 0.496,0 0.402,1.3 0.5,1.3 0.604,1.3 0.506,0 0.6,0 0.692,0 0.602,1.3 0.7,1.3 0.798,1.3 0.698,0 0.8,0 0.896,0 0.804,1.3 0.9,1.3 1,1.3 0.906,0 1,0");

//---BLINK---//
// used for a button grow / rotate to attract attention //
CustomEase.create("blink", "M0,0 C0.250,0 0,1 0.250,1 0.5,1 0.250,0 0.5,0 0.750,0 0.5,1 0.750,1 1,1 0.750,0 1,0");


CustomEase.create("bg-wiggle", "M0,0 C0.102,0 0.094,1 0.2,1 0.298,1 0.256,0 0.354,0 0.446,0 0.402,1 0.5,1 0.604,1 0.558,0 0.654,0 0.75,0 0.702,1 0.8,1 0.904,1 0.906,0 1,0")

CustomEase.create("glow", "M0,0 C0.2,0 0.3,1 0.5,1 0.7,1 0.9,0 1,0")


// WEBPACK FOOTER //
// ./src/data/customEases.js